// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../client';
import theme from '../../../styled-components/dark';

const Wrapper = styled.div`
  ${({ $disabled }) => css`
    ${!$disabled
      ? css`
          cursor: pointer;
        `
      : css`
          pointer-events: none;
        `}
  `}
`;

const Transformer = styled.div`
  font-family: 'KabelHasbro';
  font-weight: 600;
  padding: 0.4em 1em 0.3em;
  border-radius: 1em;
  background-color: ${theme.MPPrimaryButton.backgroundColor};
  color: ${theme.MPPrimaryButton.color};
  text-shadow: 0px 2px 0px ${theme.MPPrimaryButton.textShadowColor};
  box-shadow: 0 2px 0 0 ${theme.MPPrimaryButton.backgroundShadowColor};
  font-size: 1.2em;
  user-select: none;
  transition: none 150ms ease-in-out;
  transition-property: filter, transform;
  text-align: center;

  ${({ $isSmall }) =>
    $isSmall
      ? css`
          font-size: 0.75em;
          font-weight: normal;
          box-shadow: 0 1px 0 0 ${theme.MPPrimaryButton.backgroundShadowColor};
          text-shadow: 0px 1px 0px ${theme.MPPrimaryButton.textShadowColor};
          padding: 0.125em 0.75em 0.15em;
        `
      : null}

  ${({ $disabled }) => css`
    ${!$disabled
      ? css`
          ${Target.__MOBILE__
            ? css`
                &:active {
                  filter: brightness(108%);
                  transform: scale(0.96);
                }
              `
            : css`
                &:hover {
                  filter: brightness(108%);
                }
                &:active {
                  transform: scale(0.96);
                }
              `}
        `
      : css`
          filter: brightness(0.4) grayscale(0.2);
        `}
  `}
`;

type MPPrimaryButtonProps = {
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
  isSmall?: boolean;
};

const MPPrimaryButton = ({ className = '', disabled, onClick, children, isSmall = false }: MPPrimaryButtonProps) => {
  return (
    <Wrapper className={className} onClick={onClick} $disabled={disabled}>
      <Transformer $disabled={disabled} $isSmall={isSmall}>
        {children}
      </Transformer>
    </Wrapper>
  );
};

export default MPPrimaryButton;
